import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SearchBox() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const urlQuery = sp.get('query') || '';
  
  const [query, setQuery] = useState(urlQuery);

  // Sync input with URL if it changes from outside (e.g. clicking reset)
  useEffect(() => {
    setQuery(urlQuery === 'all' ? '' : urlQuery);
  }, [urlQuery]);

  const submitHandler = (e) => {
    e.preventDefault();
    navigate(query ? `/products/?query=${query}` : '/products');
  };

  return (
    <Form className="d-flex me-auto search" onSubmit={submitHandler} style={{ width: '100%' }}>
      <InputGroup style={{ borderRadius: '12px', overflow: 'hidden', width: '100%' }}>
        <Button 
          variant="secondary" 
          type="submit" 
          id="button-search"
          style={{ 
            backgroundColor: '#801001', 
            borderColor: '#801001',
            color: '#fff',
            borderTopLeftRadius: '12px',
            borderBottomLeftRadius: '12px',
            padding: '0 15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="fas fa-search" style={{ fontSize: '0.9rem' }}></i>
        </Button>
        <FormControl
          type="text"
          name="q"
          id="q"
          value={query}
          onChange={(e) => {
            const val = e.target.value;
            setQuery(val);
            // Realtime search: if empty, go to /products to reset everything
            // Otherwise, apply the query
            navigate(val ? `/products/?query=${val}` : '/products');
          }}
          placeholder="Search for products..."
          aria-label="Search Products"
          aria-describedby="button-search"
          style={{ 
            border: 'none',
            borderTopRightRadius: '12px',
            borderBottomRightRadius: '12px',
            paddingLeft: '10px'
          }}
        ></FormControl>
      </InputGroup>
    </Form>
  );
}
